

import React from "react";
import {
    ChevronLeft,
    ChevronRight,
    CalendarIcon,
} from "lucide-react";

import {
    DatePicker,

} from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css";


/**
 * Calendar header component (navigation and title)
 */
const CalendarHeader: React.FC<{
    monthOffset: number;
    onPrev: () => void;
    onNext: () => void;
    onToday: () => void;
    onDateChange: (date: dayjs.Dayjs | null) => void;
}> = ({ monthOffset, onPrev, onNext, onToday, onDateChange }) => {
    const currentMonthStr = dayjs().add(monthOffset, "month").format("MMMM YYYY");

    return (
        <div className="flex flex-col gap-6 mb-8 relative ">
            <div className="flex items-center justify-between px-2 ">
                <h2 className="text-2xl font-black text-gray-900 capitalize tracking-tight">{currentMonthStr}</h2>

                {/* Navigation controls (Prev Month, Today, Picker, Next Month) */}
                <div className="flex items-center gap-2 bg-white rounded-xl border border-gray-100 p-1.5 shadow-sm">
                    <button
                        onClick={onPrev}
                        className="p-1.5 text-gray-400 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-all"
                    >
                        <ChevronLeft size={20} />
                    </button>
                    <button
                        onClick={onToday}
                        className="px-4 text-xs font-black text-gray-500 hover:text-[#3d5a35] uppercase tracking-widest transition-colors"
                    >
                        Today
                    </button>

                    {/* Integrated Ant Design Month Picker */}

                    <button
                        onClick={onNext}
                        className="p-1.5 text-gray-400 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-all"
                    >
                        <ChevronRight size={20} />
                    </button>
                    <DatePicker
                        picker="month"
                        onChange={onDateChange}
                        allowClear={false}
                        suffixIcon={<CalendarIcon size={16} className="text-[#3d5a35]" />}
                        className="h-11 rounded-lg border-gray-200 hover:border-[#3d5a35] focus:border-[#3d5a35] transition-all shadow-sm bg-white font-bold"
                        placeholder="Select month"
                        value={dayjs().add(monthOffset, "month")}
                    />
                </div>
            </div>
        </div>
    );
};
export default CalendarHeader;